import React from "react";
import { FormControl } from 'react-bootstrap';

export default function EventTitleField (props) {
    return (
        <FormControl
            componentClass="textarea"
            bsSize="lg"
            style={{background: "none", resize: "none", height: "2.62em"}}
            className="text-outline"
            placeholder="Event description"
            onChange={(e) => props.onChange(e.target.value)}
            onFocus={(e) => e.target.select()}
            value={props.value} />
    );
}



// WEBPACK FOOTER //
// ./src/js/EventTitleField.js